
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"2 2 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z","fill":"#E6E8EB"}}),_c('path',{attrs:{"d":"M19.9 18.131A9.983 9.983 0 0112 22a9.983 9.983 0 01-7.9-3.869c1.657-2.124 4.241-4.073 7.9-4.073 3.659 0 6.242 1.949 7.9 4.073zM14.93 8.982c0 1.647-1.375 2.982-3.07 2.982-1.696 0-3.07-1.335-3.07-2.982C8.79 7.335 10.163 6 11.86 6c1.695 0 3.07 1.335 3.07 2.982z","fill":"#AAAAAF"}})])
          )
        }
      }
    